<template>
  <div class="log" v-if="code == 1">
    <el-dropdown trigger="click" @command="handleCommand">
      <div class="log">
        <div class="img_box">
          <img v-if="info.avatarurl" :src="info.avatarurl" alt="" />
          <img v-else src="../../static/huiyuan.png" alt="" />
        </div>
        <span style="color: #fff">{{ info.name }}</span>
      </div>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="userCenter"> 个人中心 </el-dropdown-item>
        <el-dropdown-item command="logout">退出登录</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
  <div class="log" v-else>
    <div class="huiyuan"></div>
    <span @click="toLogin(0)" style="cursor: pointer">登录</span>
    <span style="margin: 0 5px">|</span>
    <span @click="toLogin(1)" style="cursor: pointer">注册</span>
  </div>
</template>

<script>
import { getUserInfo } from "@/api/index";
export default {
  data() {
    return {
      token: "",
      info: "",
      code: "",
    };
  },
  mounted() {
    this.checkInfo();
  },
  methods: {
    toLogin(key) {
      this.$router.push({ path: "/login", query: { key } });
      //   console.log(key);
    },
    checkInfo() {
      this.token = localStorage.getItem("token");
      getUserInfo({
        token: this.token,
      }).then((res) => {
        console.log(res.data.data);
        this.info = res.data.data;
        this.code = res.data.code;
      });
    },
    handleCommand(e) {
      if (e == "userCenter") {
        this.$router.push({ path: "/accuratePage" });
      } else {
        // console.log(e, "<<<<<<<<退出登录");
        location.reload();
        localStorage.removeItem("token");
        this.$router.push("/");
      }
    },
  },
};
</script>

<style lang="less" scoped>
.log {
  .huiyuan {
    width: 18px;
    height: 18px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("../../static/huiyuan.png");
    vertical-align: middle;
    margin-right: 5px;
  }
  display: flex;
  align-items: center;
  .img_box {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    border: 1px solid #eee;
    img {
      width: 100%;
      height: 100%;
    }
  }
  cursor: pointer;
}
</style>
